var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeOpacity: 0.01,
    strokeWidth: 0.01,
    d: "M0 0h24v24H0V0z",
    transform: "translate(-1100 -1364) translate(925 1251) translate(23 80) translate(152 33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43A4F1",
    d: "M16 2v2H5v16h11v2H5.003c-1.059 0-1.921-.812-1.998-1.842L3 20.009V3.991c0-1.043.817-1.909 1.853-1.985L5.003 2H16zm0 4.087l5.92 5.92-5.92 5.92v-2.87L18.03 13H9v-2h9.016L16 8.958V6.087z",
    transform: "translate(-1100 -1364) translate(925 1251) translate(23 80) translate(152 33)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCheckout);
export default __webpack_public_path__ + "static/media/icons-checkout.791e85538db63a1fd057eb614bf9b8cf.svg";
export { ForwardRef as ReactComponent };